import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component, createContext } from 'react';
import createHoc from "../createHoc.mjs";
import { interpolate, useAsyncI18nMessages } from "./i18nEnhance.mjs";
export var Context = /*#__PURE__*/createContext(undefined);
var I18nProvider = Context.Provider,
  I18nConsumer = Context.Consumer;
function getText(dictionaries, locale) {
  return function (key) {
    var dictionary = dictionaries[locale];
    return dictionary ? dictionary[key] : dictionaries['en'][key];
  };
}

/** @deprecated */
/**
 * @deprecated use `useI18n` instead
 */
var WithI18n = /*#__PURE__*/function (_Component) {
  _inherits(WithI18n, _Component);
  var _super = _createSuper(WithI18n);
  function WithI18n() {
    var _this;
    _classCallCheck(this, WithI18n);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    /* @ts-ignore */
    _defineProperty(_assertThisInitialized(_this), "context", void 0);
    _defineProperty(_assertThisInitialized(_this), "getText", function (dictionary, selfLocale) {
      var _this$props = _this.props,
        locale = _this$props.locale,
        getText = _this$props.getText;
      var contextLocale = _this.context;
      return getText(dictionary, selfLocale || locale || contextLocale);
    });
    return _this;
  }
  _createClass(WithI18n, [{
    key: "render",
    value: function render() {
      var _ref = this.props,
        children = _ref.children;
      return children({
        getText: this.getText
      });
    }
  }]);
  return WithI18n;
}(Component);
_defineProperty(WithI18n, "contextType", Context);
_defineProperty(WithI18n, "defaultProps", {
  getText: getText
});
var useI18n = function useI18n(dictionary) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
  var fallbackDictionary = arguments.length > 2 ? arguments[2] : undefined;
  var lang = React.useContext(Context);
  var resolvedDictionary = useAsyncI18nMessages(dictionary, lang || locale, fallbackDictionary);
  return React.useCallback(function (messageId, variables) {
    var _resolvedDictionary$m;
    return interpolate((_resolvedDictionary$m = resolvedDictionary[messageId]) !== null && _resolvedDictionary$m !== void 0 ? _resolvedDictionary$m : '', variables);
  }, [resolvedDictionary]);
};
export default createHoc(WithI18n);
export { useI18n, I18nProvider, I18nConsumer };
//# sourceMappingURL=WithI18n.mjs.map